import { SVGProps } from 'react';

export default function BuidingIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 13C3 12.6545 3 6.80893 3 3.498C3 3.22186 3.22386 3 3.5 3H10.5C10.7761 3 11 3.22386 11 3.5V13" stroke={fill} strokeWidth="1.5" />
      <path d="M4 3C4 2.94341 4 2.14936 4 1.49994C4 1.2238 4.22386 1 4.5 1H9.5C9.77614 1 10 1.22386 10 1.5V3" stroke={fill} strokeWidth="1.5" />
      <path d="M6 13C6 12.9077 6 11.5069 6 10.4999C6 10.2237 6.22386 10 6.5 10H7.5C7.77614 10 8 10.2239 8 10.5V13" stroke={fill} strokeWidth="1.5" />
      <path d="M1 13H13" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 6H6" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 6H9" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5 8H6" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 8H9" stroke={fill} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
